// extracted by mini-css-extract-plugin
export default {"main":"_147e40c250","tit":"_7e90e2b242","maintitle":"ef91695d04","ylw":"_2f0a246918","white":"_8d382df168","mv_title":"_9f18380034","mv_nc":"e4aab48347","mv_in":"c29efeb077"};